import { useMutation } from '@tanstack/react-query';
import { UpdateOrganizationGameBookingCodeEnabledDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

export const useUpdateOrganizationGameBookingCodeEnabled = (
    organizationId: string,
    onSuccess: () => void,
) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationGameBookingCodeEnabled', organizationId],
        mutationFn: (body: UpdateOrganizationGameBookingCodeEnabledDto) =>
            apiClient.fetchApi<{ gameBookingCodeEnabled: boolean }, UpdateOrganizationGameBookingCodeEnabledDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/game-booking-code-enabled`,
                body,
            }),
        onSuccess: (data) => {
            onSuccess();
            if (selectedOrganization && organizationId === selectedOrganization.id) {
                setSelectedOrganization({
                    ...selectedOrganization,
                    gameBookingCodeEnabled: data.gameBookingCodeEnabled,
                });
            }
        },
    });
};
